



























































import Vue from "vue";
import { LoginService, RequestService } from "@/services";
import config from "@/services/config";

const loginService = new LoginService();
const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  components: {
  },
  data: function() {
    return {
      input: {
        login: "",
        password: ""
      },
      msgError: "",
      msgSuccess: "",
      config,
    };
  },

  methods: {
    doLogin: async function() {
      const vm = this as any;
      vm.startLoading();

      const serviceCallReturnValue = await loginService.doLogin(vm.input)
        .then((result: any) => {
          if (result.status == "200" || result.status == "222" || result.status == "223") {
            //vm.$router.push({ name: 'home', params: {login: vm.input.login}});
            vm.getUser();
          } else if (result.status == "401") {
            vm.openModalError("Utente non autorizzato");
          }
          return null;
        })
        .catch(function(e) {
          vm.openModalError("Errore generico");
        });

      vm.stopLoading();
    },
    getUser: async function() {
      const homeView = config.codCliente === 'cardif' ? 'home' : 'home-prodotti';
      const vm = this as any;
      const serviceCallReturnValue = await requestService.getUser()
        .then(handleResponse)
        .then((result: any) => {
          vm.$router.push({ name: homeView, params: {user: result}});
        });
    },
    stringify: function(value: string) {
      if (value == undefined ||
          value == null) {
        return "";
      }

      return value;
    },
    openModalSuccess(msg: string) {
      const vm = this as any;
      vm.msgSuccess = msg;
      vm.$bvModal.show("modal-success-login");
    },
    closeModalSuccess() {
      const vm = this as any;
      vm.$bvModal.hide("modal-success-login");
    },
    onClickReturnSuccess() {
      const vm = this as any;
      vm.closeModalSuccess();
    },
    openModalError(msg: string) {
      const vm = this as any;
      vm.msgError = msg;
      vm.$bvModal.show("modal-error-login");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error-login");
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
  },
});
